<template>
  <Can :ability="hasAccounts">
    <SidebarGroup :group="group" />
  </Can>
</template>

<script setup lang="ts">
import type { NavGroup } from "./Group.vue";

const { hasAnyPermission } = useAppSession();
const { useCustomersWithPermission } = useAppSession();
const editableCustomers = useCustomersWithPermission("customer:edit");

const group = computed<NavGroup>(() => {
  return {
    items: [
      {
        to: "/settings/users",
        title: "Users",
        icon: "lucide:users",
        isActive: "startsWith",
        hidden: !hasAnyPermission("customer:edit"),
      },
      editableCustomers.value.length > 1 && {
        to: "/settings/accounts",
        title: "Accounts",
        icon: "lucide:building",
        isActive: "startsWith",
      },
      editableCustomers.value.length === 1 && {
        to: `/settings/accounts/${editableCustomers.value[0]}`,
        title: "Account",
        icon: "lucide:building",
        isActive: "equals",
      },
    ],
  };
});
</script>

<style scoped></style>
